// Percentages Knowledge Graph Samples
// Organized by difficulty levels with systematic naming

export const percentagesSamples = {
  fundamental: [
    {
      id: 'percent_fund_01',
      problem: "Calculate 25% of 80",
      problemType: "percentages",
      difficulty: "fundamental",
      description: "Basic percentage calculation",
      graphData: {
        nodes: [
          {
            id: "percentage",
            name: "Percentage",
            type: "concepts",
            description: "A fraction with denominator 100",
            value: "25% = 25/100",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "base_value",
            name: "Base Value",
            type: "concepts",
            description: "The original amount",
            value: "80",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "percentage_formula",
            name: "Percentage Formula",
            type: "formulas",
            description: "Percentage of a number = (percentage/100) × base",
            value: "25% of 80 = (25/100) × 80",
            importance: 10,
            x: 0, y: 0, z: 25
          },
          {
            id: "calculation",
            name: "Calculation",
            type: "values",
            description: "The mathematical computation",
            value: "0.25 × 80 = 20",
            importance: 9,
            x: 0, y: 100, z: -15
          },
          {
            id: "result",
            name: "Result",
            type: "values",
            description: "The final answer",
            value: "20",
            importance: 10,
            x: 0, y: 200, z: 0
          },
          {
            id: "percentage_calculation_formula",
            name: "Percentage Calculation Formula",
            type: "formulas",
            description: "Percentage of a number = (percentage/100) × base value",
            value: "Result = (percentage/100) × base",
            importance: 10,
            x: 0, y: 50, z: 40
          },
          {
            id: "identify_values",
            name: "Identify Values",
            type: "steps",
            description: "Recognize the percentage and base value",
            value: "Step 1: percentage = 25%, base = 80",
            importance: 8,
            x: -250, y: -50, z: 0
          },
          {
            id: "convert_percentage",
            name: "Convert Percentage",
            type: "steps",
            description: "Convert percentage to decimal",
            value: "Step 2: 25% = 25/100 = 0.25",
            importance: 9,
            x: 250, y: -50, z: 0
          },
          {
            id: "multiply_values",
            name: "Multiply Values",
            type: "steps",
            description: "Multiply decimal by base value",
            value: "Step 3: 0.25 × 80 = 20",
            importance: 10,
            x: 0, y: 100, z: 20
          },
          {
            id: "write_answer",
            name: "Write Answer",
            type: "steps",
            description: "State the final answer",
            value: "Step 4: 25% of 80 = 20",
            importance: 10,
            x: 0, y: 150, z: 20
          }
        ],
        links: [
          { from: "percentage", to: "percentage_formula", type: "used in", strength: 9 },
          { from: "base_value", to: "percentage_formula", type: "used in", strength: 9 },
          { from: "percentage_formula", to: "calculation", type: "gives", strength: 10 },
          { from: "calculation", to: "result", type: "equals", strength: 10 },
          { from: "percentage_calculation_formula", to: "result", type: "gives", strength: 10 },
          { from: "identify_values", to: "convert_percentage", type: "enables", strength: 8 },
          { from: "convert_percentage", to: "multiply_values", type: "enables", strength: 9 },
          { from: "multiply_values", to: "write_answer", type: "equals", strength: 10 }
        ]
      }
    },
    {
      id: 'percent_fund_02',
      problem: "What is 15% of 200?",
      problemType: "percentages",
      difficulty: "fundamental",
      description: "Simple percentage calculation",
      graphData: {
        nodes: [
          {
            id: "percentage",
            name: "Percentage",
            type: "concepts",
            description: "A fraction with denominator 100",
            value: "15% = 15/100",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "base_value",
            name: "Base Value",
            type: "concepts",
            description: "The original amount",
            value: "200",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "percentage_formula",
            name: "Percentage Formula",
            type: "formulas",
            description: "Percentage of a number = (percentage/100) × base",
            value: "15% of 200 = (15/100) × 200",
            importance: 10,
            x: 0, y: 0, z: 25
          },
          {
            id: "calculation",
            name: "Calculation",
            type: "values",
            description: "The mathematical computation",
            value: "0.15 × 200 = 30",
            importance: 9,
            x: 0, y: 100, z: -15
          },
          {
            id: "result",
            name: "Result",
            type: "values",
            description: "The final answer",
            value: "30",
            importance: 10,
            x: 0, y: 200, z: 0
          },
          {
            id: "percentage_calculation_formula",
            name: "Percentage Calculation Formula",
            type: "formulas",
            description: "Percentage of a number = (percentage/100) × base value",
            value: "Result = (percentage/100) × base",
            importance: 10,
            x: 0, y: 50, z: 40
          },
          {
            id: "identify_values",
            name: "Identify Values",
            type: "steps",
            description: "Recognize the percentage and base value",
            value: "Step 1: percentage = 15%, base = 200",
            importance: 8,
            x: -250, y: -50, z: 0
          },
          {
            id: "convert_percentage",
            name: "Convert Percentage",
            type: "steps",
            description: "Convert percentage to decimal",
            value: "Step 2: 15% = 15/100 = 0.15",
            importance: 9,
            x: 250, y: -50, z: 0
          },
          {
            id: "multiply_values",
            name: "Multiply Values",
            type: "steps",
            description: "Multiply decimal by base value",
            value: "Step 3: 0.15 × 200 = 30",
            importance: 10,
            x: 0, y: 100, z: 20
          },
          {
            id: "write_answer",
            name: "Write Answer",
            type: "steps",
            description: "State the final answer",
            value: "Step 4: 15% of 200 = 30",
            importance: 10,
            x: 0, y: 150, z: 20
          }
        ],
        links: [
          { from: "percentage", to: "percentage_formula", type: "used in", strength: 9 },
          { from: "base_value", to: "percentage_formula", type: "used in", strength: 9 },
          { from: "percentage_formula", to: "calculation", type: "gives", strength: 10 },
          { from: "calculation", to: "result", type: "equals", strength: 10 },
          { from: "percentage_calculation_formula", to: "result", type: "gives", strength: 10 },
          { from: "identify_values", to: "convert_percentage", type: "enables", strength: 8 },
          { from: "convert_percentage", to: "multiply_values", type: "enables", strength: 9 },
          { from: "multiply_values", to: "write_answer", type: "equals", strength: 10 }
        ]
      }
    },
    {
      id: 'percent_fund_03',
      problem: "Calculate 8% of 150",
      problemType: "percentages",
      difficulty: "fundamental",
      description: "Basic percentage calculation",
      graphData: {
        nodes: [
          {
            id: "percentage",
            name: "Percentage",
            type: "concepts",
            description: "A fraction with denominator 100",
            value: "8% = 8/100",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "base_value",
            name: "Base Value",
            type: "concepts",
            description: "The original amount",
            value: "150",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "percentage_formula",
            name: "Percentage Formula",
            type: "formulas",
            description: "Percentage of a number = (percentage/100) × base",
            value: "8% of 150 = (8/100) × 150",
            importance: 10,
            x: 0, y: 0, z: 25
          },
          {
            id: "calculation",
            name: "Calculation",
            type: "values",
            description: "The mathematical computation",
            value: "0.08 × 150 = 12",
            importance: 9,
            x: 0, y: 100, z: -15
          },
          {
            id: "result",
            name: "Result",
            type: "values",
            description: "The final answer",
            value: "12",
            importance: 10,
            x: 0, y: 200, z: 0
          },
          {
            id: "percentage_calculation_formula",
            name: "Percentage Calculation Formula",
            type: "formulas",
            description: "Percentage of a number = (percentage/100) × base value",
            value: "Result = (percentage/100) × base",
            importance: 10,
            x: 0, y: 50, z: 40
          },
          {
            id: "identify_values",
            name: "Identify Values",
            type: "steps",
            description: "Recognize the percentage and base value",
            value: "Step 1: percentage = 8%, base = 150",
            importance: 8,
            x: -250, y: -50, z: 0
          },
          {
            id: "convert_percentage",
            name: "Convert Percentage",
            type: "steps",
            description: "Convert percentage to decimal",
            value: "Step 2: 8% = 8/100 = 0.08",
            importance: 9,
            x: 250, y: -50, z: 0
          },
          {
            id: "multiply_values",
            name: "Multiply Values",
            type: "steps",
            description: "Multiply decimal by base value",
            value: "Step 3: 0.08 × 150 = 12",
            importance: 10,
            x: 0, y: 100, z: 20
          },
          {
            id: "write_answer",
            name: "Write Answer",
            type: "steps",
            description: "State the final answer",
            value: "Step 4: 8% of 150 = 12",
            importance: 10,
            x: 0, y: 150, z: 20
          }
        ],
        links: [
          { from: "percentage", to: "percentage_formula", type: "used in", strength: 9 },
          { from: "base_value", to: "percentage_formula", type: "used in", strength: 9 },
          { from: "percentage_formula", to: "calculation", type: "gives", strength: 10 },
          { from: "calculation", to: "result", type: "equals", strength: 10 },
          { from: "percentage_calculation_formula", to: "result", type: "gives", strength: 10 },
          { from: "identify_values", to: "convert_percentage", type: "enables", strength: 8 },
          { from: "convert_percentage", to: "multiply_values", type: "enables", strength: 9 },
          { from: "multiply_values", to: "write_answer", type: "equals", strength: 10 }
        ]
      }
    },
    {
      id: 'percent_fund_04',
      problem: "What is 12% of 75?",
      problemType: "percentages",
      difficulty: "fundamental",
      description: "Simple percentage calculation",
      graphData: {
        nodes: [
          {
            id: "percentage",
            name: "Percentage",
            type: "concepts",
            description: "A fraction with denominator 100",
            value: "12% = 12/100",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "base_value",
            name: "Base Value",
            type: "concepts",
            description: "The original amount",
            value: "75",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "percentage_formula",
            name: "Percentage Formula",
            type: "formulas",
            description: "Percentage of a number = (percentage/100) × base",
            value: "12% of 75 = (12/100) × 75",
            importance: 10,
            x: 0, y: 0, z: 25
          },
          {
            id: "calculation",
            name: "Calculation",
            type: "values",
            description: "The mathematical computation",
            value: "0.12 × 75 = 9",
            importance: 9,
            x: 0, y: 100, z: -15
          },
          {
            id: "result",
            name: "Result",
            type: "values",
            description: "The final answer",
            value: "9",
            importance: 10,
            x: 0, y: 200, z: 0
          },
          {
            id: "percentage_calculation_formula",
            name: "Percentage Calculation Formula",
            type: "formulas",
            description: "Percentage of a number = (percentage/100) × base value",
            value: "Result = (percentage/100) × base",
            importance: 10,
            x: 0, y: 50, z: 40
          },
          {
            id: "identify_values",
            name: "Identify Values",
            type: "steps",
            description: "Recognize the percentage and base value",
            value: "Step 1: percentage = 12%, base = 75",
            importance: 8,
            x: -250, y: -50, z: 0
          },
          {
            id: "convert_percentage",
            name: "Convert Percentage",
            type: "steps",
            description: "Convert percentage to decimal",
            value: "Step 2: 12% = 12/100 = 0.12",
            importance: 9,
            x: 250, y: -50, z: 0
          },
          {
            id: "multiply_values",
            name: "Multiply Values",
            type: "steps",
            description: "Multiply decimal by base value",
            value: "Step 3: 0.12 × 75 = 9",
            importance: 10,
            x: 0, y: 100, z: 20
          },
          {
            id: "write_answer",
            name: "Write Answer",
            type: "steps",
            description: "State the final answer",
            value: "Step 4: 12% of 75 = 9",
            importance: 10,
            x: 0, y: 150, z: 20
          }
        ],
        links: [
          { from: "percentage", to: "percentage_formula", type: "used in", strength: 9 },
          { from: "base_value", to: "percentage_formula", type: "used in", strength: 9 },
          { from: "percentage_formula", to: "calculation", type: "gives", strength: 10 },
          { from: "calculation", to: "result", type: "equals", strength: 10 },
          { from: "percentage_calculation_formula", to: "result", type: "gives", strength: 10 },
          { from: "identify_values", to: "convert_percentage", type: "enables", strength: 8 },
          { from: "convert_percentage", to: "multiply_values", type: "enables", strength: 9 },
          { from: "multiply_values", to: "write_answer", type: "equals", strength: 10 }
        ]
      }
    },
    {
      id: 'percent_fund_05',
      problem: "Calculate 30% of 120",
      problemType: "percentages",
      difficulty: "fundamental",
      description: "Basic percentage calculation",
      graphData: {
        nodes: [
          {
            id: "percentage",
            name: "Percentage",
            type: "concepts",
            description: "A fraction with denominator 100",
            value: "30% = 30/100",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "base_value",
            name: "Base Value",
            type: "concepts",
            description: "The original amount",
            value: "120",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "percentage_formula",
            name: "Percentage Formula",
            type: "formulas",
            description: "Percentage of a number = (percentage/100) × base",
            value: "30% of 120 = (30/100) × 120",
            importance: 10,
            x: 0, y: 0, z: 25
          },
          {
            id: "calculation",
            name: "Calculation",
            type: "values",
            description: "The mathematical computation",
            value: "0.30 × 120 = 36",
            importance: 9,
            x: 0, y: 100, z: -15
          },
          {
            id: "result",
            name: "Result",
            type: "values",
            description: "The final answer",
            value: "36",
            importance: 10,
            x: 0, y: 200, z: 0
          },
          {
            id: "percentage_calculation_formula",
            name: "Percentage Calculation Formula",
            type: "formulas",
            description: "Percentage of a number = (percentage/100) × base value",
            value: "Result = (percentage/100) × base",
            importance: 10,
            x: 0, y: 50, z: 40
          },
          {
            id: "identify_values",
            name: "Identify Values",
            type: "steps",
            description: "Recognize the percentage and base value",
            value: "Step 1: percentage = 30%, base = 120",
            importance: 8,
            x: -250, y: -50, z: 0
          },
          {
            id: "convert_percentage",
            name: "Convert Percentage",
            type: "steps",
            description: "Convert percentage to decimal",
            value: "Step 2: 30% = 30/100 = 0.30",
            importance: 9,
            x: 250, y: -50, z: 0
          },
          {
            id: "multiply_values",
            name: "Multiply Values",
            type: "steps",
            description: "Multiply decimal by base value",
            value: "Step 3: 0.30 × 120 = 36",
            importance: 10,
            x: 0, y: 100, z: 20
          },
          {
            id: "write_answer",
            name: "Write Answer",
            type: "steps",
            description: "State the final answer",
            value: "Step 4: 30% of 120 = 36",
            importance: 10,
            x: 0, y: 150, z: 20
          }
        ],
        links: [
          { from: "percentage", to: "percentage_formula", type: "used in", strength: 9 },
          { from: "base_value", to: "percentage_formula", type: "used in", strength: 9 },
          { from: "percentage_formula", to: "calculation", type: "gives", strength: 10 },
          { from: "calculation", to: "result", type: "equals", strength: 10 },
          { from: "percentage_calculation_formula", to: "result", type: "gives", strength: 10 },
          { from: "identify_values", to: "convert_percentage", type: "enables", strength: 8 },
          { from: "convert_percentage", to: "multiply_values", type: "enables", strength: 9 },
          { from: "multiply_values", to: "write_answer", type: "equals", strength: 10 }
        ]
      }
    }
  ],
  
  intermediate: [
    {
      id: 'percent_inter_01',
      problem: "A shirt costs $60. If there's a 20% discount, what is the final price?",
      problemType: "percentages",
      difficulty: "intermediate",
      description: "Percentage discount calculation",
      graphData: {
        nodes: [
          {
            id: "original_price",
            name: "Original Price",
            type: "concepts",
            description: "The initial cost before discount",
            value: "$60",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "discount_percentage",
            name: "Discount Percentage",
            type: "concepts",
            description: "The percentage reduction",
            value: "20%",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "discount_formula",
            name: "Discount Formula",
            type: "formulas",
            description: "Discount amount = (discount percentage/100) × original price",
            value: "Discount = (20/100) × $60",
            importance: 10,
            x: 0, y: 0, z: 25
          },
          {
            id: "discount_amount",
            name: "Discount Amount",
            type: "values",
            description: "The amount saved",
            value: "0.20 × $60 = $12",
            importance: 9,
            x: 150, y: -100, z: 20
          },
          {
            id: "final_price_formula",
            name: "Final Price Formula",
            type: "formulas",
            description: "Final price = original price - discount amount",
            value: "Final price = $60 - $12",
            importance: 10,
            x: 0, y: 50, z: 40
          },
          {
            id: "final_price",
            name: "Final Price",
            type: "values",
            description: "Price after discount",
            value: "$60 - $12 = $48",
            importance: 10,
            x: 0, y: 100, z: -15
          },
          {
            id: "identify_values",
            name: "Identify Values",
            type: "steps",
            description: "Recognize original price and discount percentage",
            value: "Step 1: original price = $60, discount = 20%",
            importance: 8,
            x: -250, y: -50, z: 0
          },
          {
            id: "calculate_discount",
            name: "Calculate Discount",
            type: "steps",
            description: "Calculate the discount amount",
            value: "Step 2: 20% of $60 = 0.20 × $60 = $12",
            importance: 9,
            x: 250, y: -50, z: 0
          },
          {
            id: "subtract_discount",
            name: "Subtract Discount",
            type: "steps",
            description: "Subtract discount from original price",
            value: "Step 3: $60 - $12 = $48",
            importance: 10,
            x: 0, y: 100, z: 20
          },
          {
            id: "write_answer",
            name: "Write Answer",
            type: "steps",
            description: "State the final price",
            value: "Step 4: Final price = $48",
            importance: 10,
            x: 0, y: 150, z: 20
          }
        ],
        links: [
          { from: "original_price", to: "discount_formula", type: "used in", strength: 9 },
          { from: "discount_percentage", to: "discount_formula", type: "used in", strength: 9 },
          { from: "discount_formula", to: "discount_amount", type: "gives", strength: 10 },
          { from: "original_price", to: "final_price_formula", type: "used in", strength: 10 },
          { from: "discount_amount", to: "final_price_formula", type: "used in", strength: 10 },
          { from: "final_price_formula", to: "final_price", type: "gives", strength: 10 },
          { from: "identify_values", to: "calculate_discount", type: "enables", strength: 8 },
          { from: "calculate_discount", to: "subtract_discount", type: "enables", strength: 9 },
          { from: "subtract_discount", to: "write_answer", type: "equals", strength: 10 }
        ]
      }
    },
    {
      id: 'percent_inter_02',
      problem: "If 15% of a number is 45, what is the number?",
      problemType: "percentages",
      difficulty: "intermediate",
      description: "Finding the base value from percentage",
      graphData: {
        nodes: [
          {
            id: "percentage",
            name: "Percentage",
            type: "concepts",
            description: "The given percentage",
            value: "15%",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "percentage_value",
            name: "Percentage Value",
            type: "concepts",
            description: "The value of the percentage",
            value: "45",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "equation_setup",
            name: "Equation Setup",
            type: "formulas",
            description: "Set up the equation: 15% of x = 45",
            value: "0.15x = 45",
            importance: 10,
            x: 0, y: 0, z: 25
          },
          {
            id: "reverse_formula",
            name: "Reverse Formula",
            type: "formulas",
            description: "Base = (percentage value / percentage) × 100",
            value: "Base = (45 / 15) × 100",
            importance: 10,
            x: 0, y: 50, z: 40
          },
          {
            id: "calculation",
            name: "Calculation",
            type: "values",
            description: "The mathematical computation",
            value: "Base = 3 × 100 = 300",
            importance: 9,
            x: 0, y: 100, z: -15
          },
          {
            id: "result",
            name: "Result",
            type: "values",
            description: "The original number",
            value: "300",
            importance: 10,
            x: 0, y: 200, z: 0
          },
          {
            id: "identify_values",
            name: "Identify Values",
            type: "steps",
            description: "Recognize percentage and its value",
            value: "Step 1: 15% of x = 45",
            importance: 8,
            x: -250, y: -50, z: 0
          },
          {
            id: "setup_equation",
            name: "Setup Equation",
            type: "steps",
            description: "Convert percentage to decimal and set up equation",
            value: "Step 2: 0.15x = 45",
            importance: 9,
            x: 250, y: -50, z: 0
          },
          {
            id: "solve_equation",
            name: "Solve Equation",
            type: "steps",
            description: "Solve for x by dividing both sides",
            value: "Step 3: x = 45 ÷ 0.15 = 300",
            importance: 10,
            x: 0, y: 100, z: 20
          },
          {
            id: "write_answer",
            name: "Write Answer",
            type: "steps",
            description: "State the original number",
            value: "Step 4: The number is 300",
            importance: 10,
            x: 0, y: 150, z: 20
          }
        ],
        links: [
          { from: "percentage", to: "equation_setup", type: "used in", strength: 9 },
          { from: "percentage_value", to: "equation_setup", type: "used in", strength: 9 },
          { from: "equation_setup", to: "reverse_formula", type: "gives", strength: 10 },
          { from: "reverse_formula", to: "calculation", type: "gives", strength: 10 },
          { from: "calculation", to: "result", type: "equals", strength: 10 },
          { from: "identify_values", to: "setup_equation", type: "enables", strength: 8 },
          { from: "setup_equation", to: "solve_equation", type: "enables", strength: 9 },
          { from: "solve_equation", to: "write_answer", type: "equals", strength: 10 }
        ]
      }
    },
    {
      id: 'percent_inter_03',
      problem: "A population increases from 5000 to 6000. What is the percentage increase?",
      problemType: "percentages",
      difficulty: "intermediate",
      description: "Percentage increase calculation",
      graphData: {
        nodes: [
          {
            id: "initial_value",
            name: "Initial Value",
            type: "concepts",
            description: "The starting amount",
            value: "5000",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "final_value",
            name: "Final Value",
            type: "concepts",
            description: "The ending amount",
            value: "6000",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "increase_formula",
            name: "Increase Formula",
            type: "formulas",
            description: "Increase amount = final value - initial value",
            value: "Increase = 6000 - 5000",
            importance: 10,
            x: 0, y: 0, z: 25
          },
          {
            id: "increase_amount",
            name: "Increase Amount",
            type: "values",
            description: "The absolute increase",
            value: "6000 - 5000 = 1000",
            importance: 9,
            x: 150, y: -100, z: 20
          },
          {
            id: "percentage_formula",
            name: "Percentage Formula",
            type: "formulas",
            description: "Percentage increase = (increase / initial) × 100",
            value: "Percentage = (1000 / 5000) × 100",
            importance: 10,
            x: 0, y: 50, z: 40
          },
          {
            id: "calculation",
            name: "Calculation",
            type: "values",
            description: "The mathematical computation",
            value: "0.2 × 100 = 20%",
            importance: 9,
            x: 0, y: 100, z: -15
          },
          {
            id: "result",
            name: "Result",
            type: "values",
            description: "The percentage increase",
            value: "20%",
            importance: 10,
            x: 0, y: 150, z: -15
          },
          {
            id: "identify_values",
            name: "Identify Values",
            type: "steps",
            description: "Recognize initial and final values",
            value: "Step 1: initial = 5000, final = 6000",
            importance: 8,
            x: -250, y: -50, z: 0
          },
          {
            id: "calculate_increase",
            name: "Calculate Increase",
            type: "steps",
            description: "Calculate the absolute increase",
            value: "Step 2: 6000 - 5000 = 1000",
            importance: 9,
            x: 250, y: -50, z: 0
          },
          {
            id: "calculate_percentage",
            name: "Calculate Percentage",
            type: "steps",
            description: "Calculate percentage increase",
            value: "Step 3: (1000/5000) × 100 = 20%",
            importance: 10,
            x: 0, y: 100, z: 20
          },
          {
            id: "write_answer",
            name: "Write Answer",
            type: "steps",
            description: "State the percentage increase",
            value: "Step 4: The population increased by 20%",
            importance: 10,
            x: 0, y: 150, z: 20
          }
        ],
        links: [
          { from: "initial_value", to: "increase_formula", type: "used in", strength: 9 },
          { from: "final_value", to: "increase_formula", type: "used in", strength: 9 },
          { from: "increase_formula", to: "increase_amount", type: "gives", strength: 10 },
          { from: "increase_amount", to: "percentage_formula", type: "used in", strength: 10 },
          { from: "initial_value", to: "percentage_formula", type: "used in", strength: 10 },
          { from: "percentage_formula", to: "calculation", type: "gives", strength: 10 },
          { from: "calculation", to: "result", type: "equals", strength: 10 },
          { from: "identify_values", to: "calculate_increase", type: "enables", strength: 8 },
          { from: "calculate_increase", to: "calculate_percentage", type: "enables", strength: 9 },
          { from: "calculate_percentage", to: "write_answer", type: "equals", strength: 10 }
        ]
      }
    },
    {
      id: 'percent_inter_04',
      problem: "If 25% of students are girls and there are 80 girls, how many students are there in total?",
      problemType: "percentages",
      difficulty: "intermediate",
      description: "Finding total from percentage",
      graphData: {
        nodes: [
          {
            id: "percentage",
            name: "Percentage",
            type: "concepts",
            description: "The given percentage",
            value: "25%",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "percentage_value",
            name: "Percentage Value",
            type: "concepts",
            description: "The value of the percentage",
            value: "80 girls",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "equation_setup",
            name: "Equation Setup",
            type: "formulas",
            description: "Set up the equation: 25% of total = 80",
            value: "0.25 × total = 80",
            importance: 10,
            x: 0, y: 0, z: 25
          },
          {
            id: "reverse_formula",
            name: "Reverse Formula",
            type: "formulas",
            description: "Total = (percentage value / percentage) × 100",
            value: "Total = (80 / 25) × 100",
            importance: 10,
            x: 0, y: 50, z: 40
          },
          {
            id: "calculation",
            name: "Calculation",
            type: "values",
            description: "The mathematical computation",
            value: "Total = 3.2 × 100 = 320",
            importance: 9,
            x: 0, y: 100, z: -15
          },
          {
            id: "result",
            name: "Result",
            type: "values",
            description: "The total number of students",
            value: "320 students",
            importance: 10,
            x: 0, y: 200, z: 0
          },
          {
            id: "identify_values",
            name: "Identify Values",
            type: "steps",
            description: "Recognize percentage and its value",
            value: "Step 1: 25% of total = 80 girls",
            importance: 8,
            x: -250, y: -50, z: 0
          },
          {
            id: "setup_equation",
            name: "Setup Equation",
            type: "steps",
            description: "Convert percentage to decimal and set up equation",
            value: "Step 2: 0.25 × total = 80",
            importance: 9,
            x: 250, y: -50, z: 0
          },
          {
            id: "solve_equation",
            name: "Solve Equation",
            type: "steps",
            description: "Solve for total by dividing both sides",
            value: "Step 3: total = 80 ÷ 0.25 = 320",
            importance: 10,
            x: 0, y: 100, z: 20
          },
          {
            id: "write_answer",
            name: "Write Answer",
            type: "steps",
            description: "State the total number of students",
            value: "Step 4: There are 320 students in total",
            importance: 10,
            x: 0, y: 150, z: 20
          }
        ],
        links: [
          { from: "percentage", to: "equation_setup", type: "used in", strength: 9 },
          { from: "percentage_value", to: "equation_setup", type: "used in", strength: 9 },
          { from: "equation_setup", to: "reverse_formula", type: "gives", strength: 10 },
          { from: "reverse_formula", to: "calculation", type: "gives", strength: 10 },
          { from: "calculation", to: "result", type: "equals", strength: 10 },
          { from: "identify_values", to: "setup_equation", type: "enables", strength: 8 },
          { from: "setup_equation", to: "solve_equation", type: "enables", strength: 9 },
          { from: "solve_equation", to: "write_answer", type: "equals", strength: 10 }
        ]
      }
    },
    {
      id: 'percent_inter_05',
      problem: "A price increases from $40 to $50. What is the percentage increase?",
      problemType: "percentages",
      difficulty: "intermediate",
      description: "Percentage increase calculation",
      graphData: {
        nodes: [
          {
            id: "initial_price",
            name: "Initial Price",
            type: "concepts",
            description: "The starting price",
            value: "$40",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "final_price",
            name: "Final Price",
            type: "concepts",
            description: "The ending price",
            value: "$50",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "increase_formula",
            name: "Increase Formula",
            type: "formulas",
            description: "Increase amount = final price - initial price",
            value: "Increase = $50 - $40",
            importance: 10,
            x: 0, y: 0, z: 25
          },
          {
            id: "increase_amount",
            name: "Increase Amount",
            type: "values",
            description: "The absolute increase",
            value: "$50 - $40 = $10",
            importance: 9,
            x: 150, y: -100, z: 20
          },
          {
            id: "percentage_formula",
            name: "Percentage Formula",
            type: "formulas",
            description: "Percentage increase = (increase / initial) × 100",
            value: "Percentage = (10 / 40) × 100",
            importance: 10,
            x: 0, y: 50, z: 40
          },
          {
            id: "calculation",
            name: "Calculation",
            type: "values",
            description: "The mathematical computation",
            value: "0.25 × 100 = 25%",
            importance: 9,
            x: 0, y: 100, z: -15
          },
          {
            id: "result",
            name: "Result",
            type: "values",
            description: "The percentage increase",
            value: "25%",
            importance: 10,
            x: 0, y: 150, z: -15
          },
          {
            id: "identify_values",
            name: "Identify Values",
            type: "steps",
            description: "Recognize initial and final prices",
            value: "Step 1: initial = $40, final = $50",
            importance: 8,
            x: -250, y: -50, z: 0
          },
          {
            id: "calculate_increase",
            name: "Calculate Increase",
            type: "steps",
            description: "Calculate the absolute increase",
            value: "Step 2: $50 - $40 = $10",
            importance: 9,
            x: 250, y: -50, z: 0
          },
          {
            id: "calculate_percentage",
            name: "Calculate Percentage",
            type: "steps",
            description: "Calculate percentage increase",
            value: "Step 3: ($10/$40) × 100 = 25%",
            importance: 10,
            x: 0, y: 100, z: 20
          },
          {
            id: "write_answer",
            name: "Write Answer",
            type: "steps",
            description: "State the percentage increase",
            value: "Step 4: The price increased by 25%",
            importance: 10,
            x: 0, y: 150, z: 20
          }
        ],
        links: [
          { from: "initial_price", to: "increase_formula", type: "used in", strength: 9 },
          { from: "final_price", to: "increase_formula", type: "used in", strength: 9 },
          { from: "increase_formula", to: "increase_amount", type: "gives", strength: 10 },
          { from: "increase_amount", to: "percentage_formula", type: "used in", strength: 10 },
          { from: "initial_price", to: "percentage_formula", type: "used in", strength: 10 },
          { from: "percentage_formula", to: "calculation", type: "gives", strength: 10 },
          { from: "calculation", to: "result", type: "equals", strength: 10 },
          { from: "identify_values", to: "calculate_increase", type: "enables", strength: 8 },
          { from: "calculate_increase", to: "calculate_percentage", type: "enables", strength: 9 },
          { from: "calculate_percentage", to: "write_answer", type: "equals", strength: 10 }
        ]
      }
    }
  ],
  
  harder: [
    {
      id: 'percent_hard_01',
      problem: "A company's profit increased by 15% in the first year and then decreased by 10% in the second year. What is the overall percentage change?",
      problemType: "percentages",
      difficulty: "harder",
      description: "Compound percentage changes",
      graphData: {
        nodes: [
          {
            id: "initial_profit",
            name: "Initial Profit",
            type: "concepts",
            description: "The starting profit",
            value: "100 (base)",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "first_year_increase",
            name: "First Year Increase",
            type: "concepts",
            description: "15% increase in first year",
            value: "15%",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "first_year_formula",
            name: "First Year Formula",
            type: "formulas",
            description: "New value = original × (1 + percentage increase)",
            value: "After first year = 100 × (1 + 0.15)",
            importance: 10,
            x: 0, y: 0, z: 25
          },
          {
            id: "after_first_year",
            name: "After First Year",
            type: "values",
            description: "Profit after first year",
            value: "100 × 1.15 = 115",
            importance: 9,
            x: 150, y: -100, z: 20
          },
          {
            id: "second_year_decrease",
            name: "Second Year Decrease",
            type: "concepts",
            description: "10% decrease in second year",
            value: "10%",
            importance: 9,
            x: -150, y: 0, z: 25
          },
          {
            id: "second_year_formula",
            name: "Second Year Formula",
            type: "formulas",
            description: "New value = previous value × (1 - percentage decrease)",
            value: "After second year = 115 × (1 - 0.10)",
            importance: 10,
            x: 0, y: 50, z: 40
          },
          {
            id: "final_profit",
            name: "Final Profit",
            type: "values",
            description: "Profit after second year",
            value: "115 × 0.90 = 103.5",
            importance: 9,
            x: 150, y: 0, z: 25
          },
          {
            id: "overall_change_formula",
            name: "Overall Change Formula",
            type: "formulas",
            description: "Overall change = (final - initial) / initial × 100",
            value: "Overall change = (103.5 - 100) / 100 × 100",
            importance: 10,
            x: 0, y: 100, z: -15
          },
          {
            id: "overall_change",
            name: "Overall Change",
            type: "values",
            description: "The net percentage change",
            value: "3.5% increase",
            importance: 10,
            x: 0, y: 150, z: -15
          },
          {
            id: "identify_values",
            name: "Identify Values",
            type: "steps",
            description: "Recognize the percentage changes",
            value: "Step 1: First year +15%, second year -10%",
            importance: 8,
            x: -250, y: -50, z: 0
          },
          {
            id: "calculate_first_year",
            name: "Calculate First Year",
            type: "steps",
            description: "Calculate profit after first year",
            value: "Step 2: 100 × 1.15 = 115",
            importance: 9,
            x: 250, y: -50, z: 0
          },
          {
            id: "calculate_second_year",
            name: "Calculate Second Year",
            type: "steps",
            description: "Calculate profit after second year",
            value: "Step 3: 115 × 0.90 = 103.5",
            importance: 10,
            x: 0, y: 100, z: 20
          },
          {
            id: "calculate_overall",
            name: "Calculate Overall",
            type: "steps",
            description: "Calculate overall percentage change",
            value: "Step 4: (103.5 - 100) / 100 × 100 = 3.5%",
            importance: 10,
            x: 0, y: 150, z: 20
          }
        ],
        links: [
          { from: "initial_profit", to: "first_year_formula", type: "used in", strength: 9 },
          { from: "first_year_increase", to: "first_year_formula", type: "used in", strength: 9 },
          { from: "first_year_formula", to: "after_first_year", type: "gives", strength: 10 },
          { from: "after_first_year", to: "second_year_formula", type: "used in", strength: 9 },
          { from: "second_year_decrease", to: "second_year_formula", type: "used in", strength: 9 },
          { from: "second_year_formula", to: "final_profit", type: "gives", strength: 10 },
          { from: "initial_profit", to: "overall_change_formula", type: "used in", strength: 10 },
          { from: "final_profit", to: "overall_change_formula", type: "used in", strength: 10 },
          { from: "overall_change_formula", to: "overall_change", type: "gives", strength: 10 },
          { from: "identify_values", to: "calculate_first_year", type: "enables", strength: 8 },
          { from: "calculate_first_year", to: "calculate_second_year", type: "enables", strength: 9 },
          { from: "calculate_second_year", to: "calculate_overall", type: "enables", strength: 10 }
        ]
      }
    },
    {
      id: 'percent_hard_02',
      problem: "If 30% of a number is 60 and 40% of the same number is 80, what is the number?",
      problemType: "percentages",
      difficulty: "harder",
      description: "Multiple percentage relationships",
      graphData: {
        nodes: [
          {
            id: "unknown_number",
            name: "Unknown Number",
            type: "concepts",
            description: "The number we need to find",
            value: "x",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "first_condition",
            name: "First Condition",
            type: "concepts",
            description: "30% of the number is 60",
            value: "30% of x = 60",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "second_condition",
            name: "Second Condition",
            type: "concepts",
            description: "40% of the number is 80",
            value: "40% of x = 80",
            importance: 9,
            x: 150, y: -100, z: 20
          },
          {
            id: "equation1_setup",
            name: "Equation 1 Setup",
            type: "formulas",
            description: "Convert first condition to equation",
            value: "0.3x = 60",
            importance: 10,
            x: -150, y: 0, z: 25
          },
          {
            id: "equation2_setup",
            name: "Equation 2 Setup",
            type: "formulas",
            description: "Convert second condition to equation",
            value: "0.4x = 80",
            importance: 10,
            x: 150, y: 0, z: 25
          },
          {
            id: "equation1_solution",
            name: "Equation 1 Solution",
            type: "formulas",
            description: "Solve first equation for x",
            value: "x = 60 ÷ 0.3 = 200",
            importance: 9,
            x: -150, y: 50, z: 40
          },
          {
            id: "equation2_solution",
            name: "Equation 2 Solution",
            type: "formulas",
            description: "Solve second equation for x",
            value: "x = 80 ÷ 0.4 = 200",
            importance: 9,
            x: 150, y: 50, z: 40
          },
          {
            id: "verification",
            name: "Verification",
            type: "values",
            description: "Both equations give same result",
            value: "x = 200",
            importance: 10,
            x: 0, y: 100, z: -15
          },
          {
            id: "identify_conditions",
            name: "Identify Conditions",
            type: "steps",
            description: "Recognize the two percentage conditions",
            value: "Step 1: 30% of x = 60 and 40% of x = 80",
            importance: 8,
            x: -250, y: -50, z: 0
          },
          {
            id: "setup_equations",
            name: "Setup Equations",
            type: "steps",
            description: "Convert percentages to decimal equations",
            value: "Step 2: 0.3x = 60 and 0.4x = 80",
            importance: 9,
            x: 250, y: -50, z: 0
          },
          {
            id: "solve_equations",
            name: "Solve Equations",
            type: "steps",
            description: "Solve both equations for x",
            value: "Step 3: x = 60 ÷ 0.3 = 200 and x = 80 ÷ 0.4 = 200",
            importance: 10,
            x: 0, y: 100, z: 20
          },
          {
            id: "verify_result",
            name: "Verify Result",
            type: "steps",
            description: "Verify both equations give same result",
            value: "Step 4: Both equations confirm x = 200",
            importance: 10,
            x: 0, y: 150, z: 20
          }
        ],
        links: [
          { from: "unknown_number", to: "first_condition", type: "satisfies", strength: 9 },
          { from: "unknown_number", to: "second_condition", type: "satisfies", strength: 9 },
          { from: "first_condition", to: "equation1_setup", type: "gives", strength: 10 },
          { from: "second_condition", to: "equation2_setup", type: "gives", strength: 10 },
          { from: "equation1_setup", to: "equation1_solution", type: "solves", strength: 10 },
          { from: "equation2_setup", to: "equation2_solution", type: "solves", strength: 10 },
          { from: "equation1_solution", to: "verification", type: "confirms", strength: 10 },
          { from: "equation2_solution", to: "verification", type: "confirms", strength: 10 },
          { from: "identify_conditions", to: "setup_equations", type: "enables", strength: 8 },
          { from: "setup_equations", to: "solve_equations", type: "enables", strength: 9 },
          { from: "solve_equations", to: "verify_result", type: "enables", strength: 10 }
        ]
      }
    },
    {
      id: 'percent_hard_03',
      problem: "A population grows by 20% every year. If the population is 5000 now, what will it be after 3 years?",
      problemType: "percentages",
      difficulty: "harder",
      description: "Compound percentage growth",
      graphData: {
        nodes: [
          {
            id: "initial_population",
            name: "Initial Population",
            type: "concepts",
            description: "The starting population",
            value: "5000",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "growth_rate",
            name: "Growth Rate",
            type: "concepts",
            description: "Annual growth percentage",
            value: "20%",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "growth_factor",
            name: "Growth Factor",
            type: "formulas",
            description: "Growth factor = 1 + growth rate",
            value: "Growth factor = 1 + 0.20 = 1.2",
            importance: 10,
            x: 0, y: 0, z: 25
          },
          {
            id: "year1_formula",
            name: "Year 1 Formula",
            type: "formulas",
            description: "Year 1 population = initial × growth factor",
            value: "Year 1 = 5000 × 1.2",
            importance: 9,
            x: -150, y: 50, z: 40
          },
          {
            id: "year1_population",
            name: "Year 1 Population",
            type: "values",
            description: "Population after first year",
            value: "5000 × 1.2 = 6000",
            importance: 9,
            x: 150, y: -100, z: 20
          },
          {
            id: "year2_formula",
            name: "Year 2 Formula",
            type: "formulas",
            description: "Year 2 population = year 1 × growth factor",
            value: "Year 2 = 6000 × 1.2",
            importance: 9,
            x: -150, y: 100, z: -15
          },
          {
            id: "year2_population",
            name: "Year 2 Population",
            type: "values",
            description: "Population after second year",
            value: "6000 × 1.2 = 7200",
            importance: 9,
            x: -150, y: 0, z: 25
          },
          {
            id: "year3_formula",
            name: "Year 3 Formula",
            type: "formulas",
            description: "Year 3 population = year 2 × growth factor",
            value: "Year 3 = 7200 × 1.2",
            importance: 10,
            x: 150, y: 100, z: -15
          },
          {
            id: "year3_population",
            name: "Year 3 Population",
            type: "values",
            description: "Population after third year",
            value: "7200 × 1.2 = 8640",
            importance: 10,
            x: 150, y: 0, z: 25
          },
          {
            id: "compound_formula",
            name: "Compound Formula",
            type: "formulas",
            description: "Final = Initial × (growth factor)^years",
            value: "5000 × (1.2)^3 = 8640",
            importance: 10,
            x: 0, y: 150, z: -15
          },
          {
            id: "identify_values",
            name: "Identify Values",
            type: "steps",
            description: "Recognize initial population and growth rate",
            value: "Step 1: initial = 5000, growth rate = 20%",
            importance: 8,
            x: -250, y: -50, z: 0
          },
          {
            id: "calculate_growth_factor",
            name: "Calculate Growth Factor",
            type: "steps",
            description: "Calculate the growth factor",
            value: "Step 2: growth factor = 1 + 0.20 = 1.2",
            importance: 9,
            x: 250, y: -50, z: 0
          },
          {
            id: "calculate_yearly",
            name: "Calculate Yearly",
            type: "steps",
            description: "Calculate population for each year",
            value: "Step 3: Year 1 = 5000 × 1.2 = 6000, Year 2 = 6000 × 1.2 = 7200, Year 3 = 7200 × 1.2 = 8640",
            importance: 10,
            x: 0, y: 100, z: 20
          },
          {
            id: "write_answer",
            name: "Write Answer",
            type: "steps",
            description: "State the final population",
            value: "Step 4: Population after 3 years = 8640",
            importance: 10,
            x: 0, y: 150, z: 20
          }
        ],
        links: [
          { from: "initial_population", to: "growth_factor", type: "used in", strength: 9 },
          { from: "growth_rate", to: "growth_factor", type: "used in", strength: 9 },
          { from: "growth_factor", to: "year1_formula", type: "used in", strength: 10 },
          { from: "initial_population", to: "year1_formula", type: "used in", strength: 10 },
          { from: "year1_formula", to: "year1_population", type: "gives", strength: 10 },
          { from: "year1_population", to: "year2_formula", type: "used in", strength: 9 },
          { from: "growth_factor", to: "year2_formula", type: "used in", strength: 9 },
          { from: "year2_formula", to: "year2_population", type: "gives", strength: 10 },
          { from: "year2_population", to: "year3_formula", type: "used in", strength: 9 },
          { from: "growth_factor", to: "year3_formula", type: "used in", strength: 9 },
          { from: "year3_formula", to: "year3_population", type: "gives", strength: 10 },
          { from: "initial_population", to: "compound_formula", type: "used in", strength: 10 },
          { from: "compound_formula", to: "year3_population", type: "equals", strength: 10 },
          { from: "identify_values", to: "calculate_growth_factor", type: "enables", strength: 8 },
          { from: "calculate_growth_factor", to: "calculate_yearly", type: "enables", strength: 9 },
          { from: "calculate_yearly", to: "write_answer", type: "enables", strength: 10 }
        ]
      }
    },
    {
      id: 'percent_hard_04',
      problem: "If 25% of A equals 40% of B, and B is 50, what is A?",
      problemType: "percentages",
      difficulty: "harder",
      description: "Percentage relationship between variables",
      graphData: {
        nodes: [
          {
            id: "variable_a",
            name: "Variable A",
            type: "concepts",
            description: "The unknown variable",
            value: "A",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "variable_b",
            name: "Variable B",
            type: "concepts",
            description: "The known variable",
            value: "B = 50",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "relationship",
            name: "Relationship",
            type: "concepts",
            description: "25% of A = 40% of B",
            value: "0.25A = 0.4B",
            importance: 10,
            x: 150, y: -100, z: 20
          },
          {
            id: "equation_setup",
            name: "Equation Setup",
            type: "formulas",
            description: "Set up the equation with percentages",
            value: "0.25A = 0.4B",
            importance: 10,
            x: 0, y: 0, z: 25
          },
          {
            id: "substitution",
            name: "Substitution",
            type: "values",
            description: "Substitute B = 50",
            value: "0.25A = 0.4 × 50 = 20",
            importance: 9,
            x: 0, y: 50, z: 40
          },
          {
            id: "solve_equation",
            name: "Solve Equation",
            type: "formulas",
            description: "Solve for A by dividing both sides",
            value: "A = 20 ÷ 0.25",
            importance: 10,
            x: 0, y: 100, z: -15
          },
          {
            id: "solution",
            name: "Solution",
            type: "values",
            description: "Solve for A",
            value: "A = 20 ÷ 0.25 = 80",
            importance: 10,
            x: 0, y: 150, z: -15
          },
          {
            id: "identify_relationship",
            name: "Identify Relationship",
            type: "steps",
            description: "Recognize the percentage relationship",
            value: "Step 1: 25% of A = 40% of B",
            importance: 8,
            x: -250, y: -50, z: 0
          },
          {
            id: "setup_equation",
            name: "Setup Equation",
            type: "steps",
            description: "Convert percentages to decimal equation",
            value: "Step 2: 0.25A = 0.4B",
            importance: 9,
            x: 250, y: -50, z: 0
          },
          {
            id: "substitute_value",
            name: "Substitute Value",
            type: "steps",
            description: "Substitute B = 50 into equation",
            value: "Step 3: 0.25A = 0.4 × 50 = 20",
            importance: 10,
            x: 0, y: 100, z: 20
          },
          {
            id: "solve_for_a",
            name: "Solve for A",
            type: "steps",
            description: "Solve the equation for A",
            value: "Step 4: A = 20 ÷ 0.25 = 80",
            importance: 10,
            x: 0, y: 150, z: 20
          }
        ],
        links: [
          { from: "variable_a", to: "relationship", type: "related to", strength: 9 },
          { from: "variable_b", to: "relationship", type: "related to", strength: 9 },
          { from: "relationship", to: "equation_setup", type: "gives", strength: 10 },
          { from: "equation_setup", to: "substitution", type: "enables", strength: 10 },
          { from: "variable_b", to: "substitution", type: "used in", strength: 9 },
          { from: "substitution", to: "solve_equation", type: "enables", strength: 10 },
          { from: "solve_equation", to: "solution", type: "gives", strength: 10 },
          { from: "identify_relationship", to: "setup_equation", type: "enables", strength: 8 },
          { from: "setup_equation", to: "substitute_value", type: "enables", strength: 9 },
          { from: "substitute_value", to: "solve_for_a", type: "enables", strength: 10 }
        ]
      }
    },
    {
      id: 'percent_hard_05',
      problem: "A mixture contains 30% alcohol. If 20% of the mixture is removed and replaced with pure alcohol, what is the new percentage of alcohol?",
      problemType: "percentages",
      difficulty: "harder",
      description: "Complex mixture percentage problem",
      graphData: {
        nodes: [
          {
            id: "original_mixture",
            name: "Original Mixture",
            type: "concepts",
            description: "The initial mixture",
            value: "100 units, 30% alcohol",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "removal_percentage",
            name: "Removal Percentage",
            type: "concepts",
            description: "Percentage of mixture removed",
            value: "20%",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "removal_calculation",
            name: "Removal Calculation",
            type: "formulas",
            description: "Calculate amount removed and alcohol removed",
            value: "20 units removed, 6 units alcohol removed",
            importance: 10,
            x: 0, y: 0, z: 25
          },
          {
            id: "alcohol_removed",
            name: "Alcohol Removed",
            type: "values",
            description: "20% of mixture removed",
            value: "20 units removed, 6 units alcohol",
            importance: 9,
            x: -150, y: -100, z: 20
          },
          {
            id: "remaining_calculation",
            name: "Remaining Calculation",
            type: "formulas",
            description: "Calculate remaining mixture and alcohol",
            value: "80 units remaining, 24 units alcohol",
            importance: 10,
            x: 0, y: 50, z: 40
          },
          {
            id: "remaining_mixture",
            name: "Remaining Mixture",
            type: "values",
            description: "80 units remaining",
            value: "80 units, 24 units alcohol",
            importance: 9,
            x: 150, y: -100, z: 20
          },
          {
            id: "pure_alcohol_added",
            name: "Pure Alcohol Added",
            type: "values",
            description: "20 units pure alcohol added",
            value: "20 units pure alcohol",
            importance: 9,
            x: -150, y: 0, z: 25
          },
          {
            id: "final_calculation",
            name: "Final Calculation",
            type: "formulas",
            description: "Calculate final mixture composition",
            value: "100 units total, 44 units alcohol",
            importance: 10,
            x: 0, y: 100, z: -15
          },
          {
            id: "final_mixture",
            name: "Final Mixture",
            type: "values",
            description: "100 units total",
            value: "100 units, 44 units alcohol",
            importance: 10,
            x: 150, y: 0, z: 25
          },
          {
            id: "final_percentage",
            name: "Final Percentage",
            type: "values",
            description: "The new alcohol percentage",
            value: "44% alcohol",
            importance: 10,
            x: 0, y: 150, z: -15
          },
          {
            id: "identify_values",
            name: "Identify Values",
            type: "steps",
            description: "Recognize initial mixture and removal percentage",
            value: "Step 1: 100 units, 30% alcohol, 20% removed",
            importance: 8,
            x: -250, y: -50, z: 0
          },
          {
            id: "calculate_removal",
            name: "Calculate Removal",
            type: "steps",
            description: "Calculate amount and alcohol removed",
            value: "Step 2: 20 units removed, 6 units alcohol removed",
            importance: 9,
            x: 250, y: -50, z: 0
          },
          {
            id: "calculate_remaining",
            name: "Calculate Remaining",
            type: "steps",
            description: "Calculate remaining mixture",
            value: "Step 3: 80 units remaining, 24 units alcohol",
            importance: 10,
            x: 0, y: 100, z: 20
          },
          {
            id: "calculate_final",
            name: "Calculate Final",
            type: "steps",
            description: "Add pure alcohol and calculate final percentage",
            value: "Step 4: 24 + 20 = 44 units alcohol, 44%",
            importance: 10,
            x: 0, y: 150, z: 20
          }
        ],
        links: [
          { from: "original_mixture", to: "removal_calculation", type: "used in", strength: 9 },
          { from: "removal_percentage", to: "removal_calculation", type: "used in", strength: 9 },
          { from: "removal_calculation", to: "alcohol_removed", type: "gives", strength: 10 },
          { from: "original_mixture", to: "remaining_calculation", type: "used in", strength: 9 },
          { from: "alcohol_removed", to: "remaining_calculation", type: "used in", strength: 10 },
          { from: "remaining_calculation", to: "remaining_mixture", type: "gives", strength: 10 },
          { from: "remaining_mixture", to: "final_calculation", type: "used in", strength: 9 },
          { from: "pure_alcohol_added", to: "final_calculation", type: "used in", strength: 9 },
          { from: "final_calculation", to: "final_mixture", type: "gives", strength: 10 },
          { from: "final_mixture", to: "final_percentage", type: "has", strength: 10 },
          { from: "identify_values", to: "calculate_removal", type: "enables", strength: 8 },
          { from: "calculate_removal", to: "calculate_remaining", type: "enables", strength: 9 },
          { from: "calculate_remaining", to: "calculate_final", type: "enables", strength: 10 }
        ]
      }
    }
  ]
}; 